import { render, staticRenderFns } from "./WidgetNetworkStatsByDesti.vue?vue&type=template&id=9bdd3d76"
import script from "./WidgetNetworkStatsByDesti.vue?vue&type=script&lang=js"
export * from "./WidgetNetworkStatsByDesti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports